import logo from './logo.svg';
import './App.css';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import PickupForm from './PickupForm';
import AdminLogin from './AdminLogin';
import AdminPortal from './AdminPortal';
import UpdateHoliday from './UpdateHoliday';
import UpdateSpecialist from './UpdateSpecialist';
import FormSubmit from './FormSubmit';
import Statistic from './Statistic';
import Question from './Question';
import { AirportPickupDataProvider } from './AirportPickupDataContext';


function App() {
    ReactDOM.render(
        <Router>
            <AirportPickupDataProvider>
            <Routes>
                <Route path="/" element={<PickupForm />} />             
                <Route path="/pickupForm" element={<PickupForm />} />
                <Route path="/adminLogin" element={<AdminLogin />} />
                <Route path="/adminPortal" element={<AdminPortal />} />
                <Route path="/updateHoliday" element={<UpdateHoliday />} />
                <Route path="/updateSpecialist" element={<UpdateSpecialist />} />
                <Route path="/formSubmit" element={<FormSubmit />} />
                <Route path="/statistic" element={<Statistic />} />
                <Route path="/question" element={<Question />} />
                </Routes>
            </AirportPickupDataProvider>
        </Router>,
        document.getElementById('root')
    );
}

export default App;
